module.exports = __webpack_public_path__ + "img/Lottery.81e48ad.png";